import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  return <AnimatePresence data-id="element-105">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
        backgroundColor: 'rgba(5,10,20,0.85)',
        backdropFilter: 'blur(6px)'
      }} data-id="element-106" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-107">
            <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-8 pointer-events-auto" style={{
          backgroundColor: '#0C1628',
          border: '1px solid rgba(14,165,233,0.2)',
          boxShadow: '0 0 80px rgba(14,165,233,0.1)'
        }} data-id="element-108">
              <button onClick={onClose} className="absolute top-5 right-5 p-2 rounded-full transition-colors" style={{
            color: '#475569',
            backgroundColor: 'rgba(14,165,233,0.06)'
          }} data-id="element-109">
                <X size={18} data-id="element-110" />
              </button>

              <h2 className="text-2xl font-black mb-1" style={{
            color: '#F1F5F9'
          }} data-id="element-111">
                Política de Privacidad
              </h2>
              <p className="text-xs mb-8" style={{
            color: '#475569'
          }} data-id="element-112">
                Última actualización: febrero 2026
              </p>

              <div className="space-y-6 text-sm leading-relaxed" style={{
            color: '#94A3B8'
          }} data-id="element-113">
                <section data-id="element-114">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-115">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-116">
                    Al realizar una compra o interactuar con nuestro sitio,
                    podemos recopilar la siguiente información:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-117">
                    <li data-id="element-118">Nombre y apellido</li>
                    <li data-id="element-119">Dirección de correo electrónico</li>
                    <li data-id="element-120">
                      Información de pago (procesada de forma segura por
                      terceros)
                    </li>
                    <li data-id="element-121">Dirección IP y datos de navegación</li>
                  </ul>
                </section>

                <section data-id="element-122">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-123">
                    2. Cómo Usamos tu Información
                  </h3>
                  <p data-id="element-124">Utilizamos tu información personal para:</p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-125">
                    <li data-id="element-126">Procesar y entregar tu compra</li>
                    <li data-id="element-127">
                      Enviarte confirmaciones y actualizaciones del producto
                    </li>
                    <li data-id="element-128">Brindarte soporte al cliente</li>
                    <li data-id="element-129">Mejorar nuestros productos y servicios</li>
                    <li data-id="element-130">
                      Enviarte comunicaciones de marketing (con tu
                      consentimiento)
                    </li>
                  </ul>
                </section>

                <section data-id="element-131">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-132">
                    3. Protección de Datos
                  </h3>
                  <p data-id="element-133">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger tu información personal contra acceso no
                    autorizado, pérdida o divulgación. Los pagos son procesados
                    por plataformas certificadas PCI-DSS. Nunca almacenamos
                    datos de tarjetas de crédito en nuestros servidores.
                  </p>
                </section>

                <section data-id="element-134">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-135">
                    4. Compartir Información con Terceros
                  </h3>
                  <p data-id="element-136">
                    No vendemos, alquilamos ni compartimos tu información
                    personal con terceros con fines comerciales. Podemos
                    compartir datos con proveedores de servicios que nos ayudan
                    a operar nuestro negocio (procesadores de pago, plataformas
                    de email), quienes están obligados a mantener la
                    confidencialidad.
                  </p>
                </section>

                <section data-id="element-137">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-138">
                    5. Cookies
                  </h3>
                  <p data-id="element-139">
                    Nuestro sitio utiliza cookies para mejorar tu experiencia de
                    navegación, analizar el tráfico del sitio y personalizar el
                    contenido. Puedes configurar tu navegador para rechazar
                    cookies, aunque esto puede afectar algunas funcionalidades
                    del sitio.
                  </p>
                </section>

                <section data-id="element-140">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-141">
                    6. Tus Derechos
                  </h3>
                  <p data-id="element-142">Tienes derecho a:</p>
                  <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-143">
                    <li data-id="element-144">Acceder a los datos personales que tenemos sobre ti</li>
                    <li data-id="element-145">Solicitar la corrección de datos inexactos</li>
                    <li data-id="element-146">Solicitar la eliminación de tus datos</li>
                    <li data-id="element-147">Oponerte al procesamiento de tus datos</li>
                    <li data-id="element-148">
                      Cancelar la suscripción a comunicaciones de marketing
                    </li>
                  </ul>
                </section>

                <section data-id="element-149">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-150">
                    7. Retención de Datos
                  </h3>
                  <p data-id="element-151">
                    Conservamos tu información personal durante el tiempo
                    necesario para cumplir con los propósitos descritos en esta
                    política, a menos que la ley exija un período de retención
                    más largo.
                  </p>
                </section>

                <section data-id="element-152">
                  <h3 className="font-bold mb-2" style={{
                color: '#38BDF8'
              }} data-id="element-153">
                    8. Contacto
                  </h3>
                  <p data-id="element-154">
                    Para ejercer tus derechos o consultas sobre privacidad:{' '}
                    <span style={{
                  color: '#38BDF8'
                }} data-id="element-155">
                      privacidad@arquitectosdelfuturo.com
                    </span>
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}